export function formatCity(dataLivraison: any) {
    if (
        !dataLivraison?.STVilleLivraison ||
        !Array.isArray(dataLivraison.STVilleLivraison)
    ) {
        return [];
    }

    let data: any[] = [];

    dataLivraison.STVilleLivraison.forEach((element: any) => {
        data.push({
            Department: element.Department,
            CodePostale: element.CodePostale,
            NomVille: element.NomVille,
            MinCommande: element.MinCommande,
            FraisLivraison: element.FraisLivraison,
            idTva: element.idTva, // Use the existing idTva directly like in formatZone
            TauxTva: element.TauxTva,
            detailsVille: `\u001bPG+4260 ${
                element.NomVille
            } \u001bPG-: Frais liv : ${convertToRealNumber(
                element.FraisLivraison
            )} € \u001bPG- - Min CMD : ${convertToRealNumber(
                element.MinCommande
            )} €`,
            InfoVille: `\u001bPG+ ${
                element.NomVille
            } :\u001bPG- (Frais de liv: ${convertToRealNumber(
                element.FraisLivraison
            )} € - Min commande: ${convertToRealNumber(
                element.MinCommande
            )} €)`,
            Pays: element.Pays,
            CodePays: element.codePays,
            SousVille: element.SousVille,
        });
    });

    return data;
}
export function convertToRealNumber(integer: any) {
    return parseFloat(integer).toFixed(2);
}
export function removeLeadingZeros(number: string): number {
    let result: string = parseInt(number, 10).toString();
    if (result.includes(".")) {
        return parseFloat(result);
    } else {
        return parseInt(result, 10);
    }
}
